import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Dialog from 'shared/molecules/Dialog';
import CircularSpinner from 'shared/atoms/CircularSpinner';
import SearchField from 'shared/atoms/SearchField';
import Alert from 'shared/atoms/Alert';
import theme from 'shared/themes/default';

import CopyPlaylistPanel from './CopyPlaylistPanel';
import { usePlaylist } from '../../../../context';
import { newSelectTranslation } from '../../../../../../utils';

const SideSpaceWrapper = styled.div`
  padding: 0 1rem;
`;

const Spacer = styled.div`
  height: ${theme.spacing.m1};
`;

const StyledInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

function SelectExistingPlaylist({
  existingPlaylists,
  existingPlaylistsLoading,
  handleSubmit,
  onClose,
  formStatus,
  submitting,
}) {
  const [playlistSelected, setPlaylistSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const { locale } = usePlaylist();

  const { t } = useTranslation();

  const actions = [
    {
      disabled: formStatus || !playlistSelected,
      handler: () => handleSubmit(playlistSelected),
      label: t('playlist.savePlaylistText'),
    },
  ];

  return (
    <Dialog
      open
      onClose={onClose}
      ariaLabel="select-existing-playlist-dialog"
      title={t('playlist.copyPlaylistTitle')}
      loading={submitting}
      actions={actions}
      contentPadding="0"
      formStatus={formStatus}
      scrollType="body"
    >
      {formStatus && (
        <SideSpaceWrapper>
          <Alert
            message={formStatus.message}
            severity={formStatus.success ? 'success' : 'error'}
            theme="light"
          />
        </SideSpaceWrapper>
      )}
      {!formStatus &&
        (existingPlaylistsLoading ? (
          <CircularSpinner />
        ) : (
          <StyledInnerWrapper>
            <SideSpaceWrapper>
              <SearchField
                theme="light"
                placeholder={t('playlist.searchPlaylistHolder')}
                value={searchTerm}
                onClear={() => setSearchTerm('')}
                ariaLabel={t('playlist.searchPlaylistHolder')}
                onChange={({ value }) => setSearchTerm(value)}
              />
            </SideSpaceWrapper>
            <Spacer />
            <CopyPlaylistPanel
              setPlaylistSelected={setPlaylistSelected}
              existingPlaylists={
                searchTerm
                  ? existingPlaylists.filter((playlist) =>
                      newSelectTranslation(playlist.name, locale)
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    )
                  : existingPlaylists
              }
            />
          </StyledInnerWrapper>
        ))}
    </Dialog>
  );
}

SelectExistingPlaylist.propTypes = {
  existingPlaylists: PropTypes.array.isRequired,
  existingPlaylistsLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  formStatus: PropTypes.object,
};

export default SelectExistingPlaylist;
